import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OfficeDetailsCard.css";
import { Company } from "../models/company";
import { apiCall } from "../api/apiCall";
import { useTranslation } from "../i18n/UseTranslation";
import ConfirmDialog from "../components/Navbar/ConfirmLogoutDialog";

function OfficeDetailsCard({ company }: { company: Company }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translations = t.officeDetailsCard;

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const replaceName = (message: string, name: string) =>
    message.replace("{name}", name);

  const handleDeleteClick = () => {
    setIsDeleteDialogOpen(true);
  };

  const executeDelete = async () => {
    setIsDeleteDialogOpen(false);

    try {
      await apiCall(`/companies/${company.uuid}`, {
        method: "DELETE",
      });

      alert(translations.deleteSuccess);
      navigate("/offices");
    } catch (error) {
      console.error("Error deleting office:", error);
      alert(translations.deleteError);
    }
  };

  return (
    <div className="dashboard-wrapper office-detail-page">
      <div className="office-card-detail">
        <h2 className="office-title-detail">{company.name}</h2>

        <p className="office-type-detail">
          {translations.structureType}:{" "}
          {company.is_platform
            ? translations.platformSystem
            : translations.clientCompany}
        </p>

        <p className="office-uuid-detail mono">
          {translations.id}: {company.uuid}
        </p>

        <div className="header-actions-detail">
          <button
            type="button"
            className="patch-office-cancel"
            onClick={() => navigate(-1)}
          >
            {translations.cancel}
          </button>

          <button
            type="button"
            className="office-delete-btn"
            onClick={handleDeleteClick}
          >
            {translations.deleteOffice}
          </button>
        </div>
      </div>

      {/* Ajout de la modale de confirmation */}
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title={t.common?.deleteConfirmTitle || "Confirmer la suppression"}
        content={replaceName(translations.deleteConfirm, company.name)}
        cancelText={t.common?.cancel || "Annuler"}
        confirmText={translations.deleteOffice || "Supprimer"}
        onCancel={() => setIsDeleteDialogOpen(false)}
        onConfirm={executeDelete}
        variant="danger"
      />
    </div>
  );
}

export default OfficeDetailsCard;
